import "./assets/sass/main.scss";
import "./plugins";
import "./filters";

import Vue from "vue";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";

Vue.component(
  "guide-link-button",
  require("./components/GuideLinkButton.vue").default
);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
